import { render, staticRenderFns } from "./SignInRight.vue?vue&type=template&id=2bb8bd1b&scoped=true&"
import script from "./SignInRight.vue?vue&type=script&lang=js&"
export * from "./SignInRight.vue?vue&type=script&lang=js&"
import style0 from "./SignInRight.vue?vue&type=style&index=0&id=2bb8bd1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8bd1b",
  null
  
)

export default component.exports